/* eslint-disable warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import PaymentMethod from '@linc-technologies/linced-common/enums/payment-method';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TillSessionsController extends Controller {
  // Services
  @service
  roles;

  @service
  session;

  @service
  store;

  PaymentMethod = PaymentMethod;
  @tracked
  dialogOpen = false;
  @tracked
  tillSession = null;
  @tracked
  tillSessionLoading = false;
  @tracked
  saveInProgress = false;
  @tracked
  transactions = null;
  @tracked
  cancelled = null;
  @tracked
  discrepancies = null;

  @action
  openDialog(tillSession) {
    this.tillSession = tillSession;
    this.dialogOpen = true;
    this.tillSessionLoading = true;
    hash({
      transactions: this.store.query('finance/transaction', {
        tillSessionId: tillSession.id,
      }),
      cancelled: this.store.query('finance/transaction', {
        isCancelled: true,
        cancellationTillSessionId: tillSession.id,
      }),
      discrepancies: this.store.query('finance/discrepancy', {
        tillSessionId: tillSession.id,
      }),
      tillSession: tillSession.reload(),
    }).then((data) => {
      this.transactions = data.transactions;
      this.cancelled = data.cancelled;
      this.discrepancies = data.discrepancies;
      this.tillSessionLoading = false;
    });
  }

  @action
  closeDialog() {
    // Revert any unsaved changes before closing dialog.
    this.tillSession.rollbackAttributes();
    this.tillSession = null;
    this.tillSessionLoading = false;
    this.dialogOpen = false;
    this.transactions = null;
    this.cancelled = null;
    this.discrepancies = null;
  }

  @action
  save() {
    this.saveInProgress = true;
    this.tillSession
      .save()
      .then(() => {
        this.toaster.success('Till Session saved successfully.');
        this.dialogOpen = false;
      })
      .catch(() => {
        this.toaster.error('Error saving Till Session!');
      })
      .finally(() => {
        this.saveInProgress = false;
      });
  }

  @action
  editDiscrepancy() {}
}
